// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* ! Keep the postcss scoped ! */.animate-it[data-v-53469424]{opacity:0;transform:translate3d(0,-70px,0);transition:.7s}.animate-it.animation-trigger[data-v-53469424]{opacity:1!important;transform:translateZ(0)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
